export const PERMISSIONS = {
  // Document
  DOCUMENT_VIEW: 'document.view',
  DOCUMENT_CREATE: 'document.create',
  DOCUMENT_UPDATE: 'document.update',
  DOCUMENT_DELETE: 'document.delete',
  DOCUMENT_SCAN: 'document.scan',
  DOCUMENT_REVIEW_SCAN: 'document.review_scan',
  DOCUMENT_INPUT: 'document.input',
  DOCUMENT_REVIEW_INPUT: 'document.review_input',
  DOCUMENT_SIGN: 'document.sign',
  DOCUMENT_PACKAGE: 'document.package',

  // Folder
  FOLDER_UPDATE: 'folder.update',
  FOLDER_INPUT: 'folder.input',

  // Project
  PROJECTS_UPDATE: 'projects.update',
  PROJECTS_DELETE: 'projects.delete',
  PROJECTS_WRITE: 'projects.write',
  PROJECTS_CREATE: 'projects.create',
  PROJECTS_READ: 'projects.read',

  // User
  USERS_MANAGE: 'users.manage',
  USERS_READ: 'users.read',
  USERS_DELETE: 'users.delete',
  USERS_CREATE: 'users.create',
  USERS_UPDATE: 'users.update',

  // Scanner
  SCANNER_ACCESS: 'scanner.access',

  // RBAC
  RBAC_READ: 'rbac.read',
  RBAC_WRITE: 'rbac.write',
} as const;

export type PermissionKey = keyof typeof PERMISSIONS;
